import $ from 'jquery';

const portalId = '6793681';
const formGuid = '12237cf4-c69a-46f7-87e9-ac84b81f0e03';
const hubspotSubmitEndpoint = `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formGuid}`;

export default function popupSection() {
	if (location.search === '?invalidatePopup') {
		localStorage.removeItem('openedPopup')
	}

	const $popupModal = $('#hubspot-form-modal');
	const openedPopup = localStorage.getItem('openedPopup');
	if ($popupModal.hasClass('should-open') && !openedPopup) {
		localStorage.setItem('openedPopup', true);
		$popupModal.data('toggler').open();
	}

	if ($popupModal.hasClass('should-open')) {
		$('.heading_button').click(() => {
			$popupModal.data('toggler').open();
		});
	}

	const $form = $popupModal.find('.form');

	const $firstNameField = $form.find('.first-name-field input');
	const $lastNameField = $form.find('.first-name-field input');
	const $emailField = $form.find('.email-field input');
	const $submitButton = $form.find('button');

	$submitButton.click(() => {
		const xhr = new XMLHttpRequest();

		const data = {
			fields: [
				{
					name: 'firstname',
					value: $firstNameField.val()
				},
				// {
				// 	name: 'lastname',
				// 	value: $lastNameField.val()
				// },
				{
					name: 'email',
					value: $emailField.val()
				}
			]
		};

		const body = JSON.stringify(data);

		xhr.open('POST', hubspotSubmitEndpoint);
		xhr.setRequestHeader('Content-Type', 'application/json');

		xhr.onreadystatechange = () => {
			if(xhr.readyState == 4 && xhr.status == 200) { 
				$popupModal.find('.modal_content').html(`
					<div class="text">
						${JSON.parse(xhr.responseText).inlineMessage}
					</div>
				`);
			}
		};

		xhr.send(body);
	});
}



// WEBPACK FOOTER //
// ./source/scripts/sections/popup.js